import { useMutation, UseMutationOptions } from 'react-query';
import apiClient from 'src/queries/apiClient';
import { ApiResponseType, responseWrapper } from 'src/queries/helpers';
import { TravelRequestDetailResponse, UpsertTravelRequestPayload } from './types';

export function useUpdateTravelRequest(
  options?: UseMutationOptions<
    ApiResponseType<TravelRequestDetailResponse>,
    Error,
    UpsertTravelRequestPayload
  >
) {
  const {
    mutate: updateTravelRequest,
    data,
    isLoading,
    isSuccess,
  } = useMutation<ApiResponseType<TravelRequestDetailResponse>, Error, UpsertTravelRequestPayload>({
    mutationFn: (payload: UpsertTravelRequestPayload) =>
      responseWrapper(apiClient.updateTravelRequest, [payload]),
    ...options,
  });

  return {
    updateTravelRequest,
    data,
    isLoading,
    isSuccess,
  };
}
